import * as React from 'react';
import { config } from 'config';
import { Item } from 'types';
import { Button, Dialog } from 'arbina-ui';
import Input from 'arbina-ui/build/components/Input';
import * as style from './style.sass';
import { Cropper } from './components/Cropper';
import { Indices } from './components/Indices';
import { DisabledIndices } from './components/DisabledIndices';
import * as ImageCropper from 'react-image-crop';

interface Properties {
  item: Item;
  onClose: () => any;
  onSubmit: (item: Item) => any;
}

interface State {
  item: Item;
  chosenFile: File | null;
}

export class ItemEditor extends React.Component<Properties> {
  state: State = {
    item: this.props.item,
    chosenFile: null,
  };

  onFileChosen = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;

    this.setState({
      ...this.state,
      chosenFile: file,
      item: {
        ...this.state.item,
        originalFile: file,
      },
    });
  }

  onWidthChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    const size = +event.target.value;
    const maxIndex = size ** 2 - 1;
    const { item } = this.state;

    this.setState({
      ...this.state,
      item: {
        ...this.state.item,
        width: size,
        height: size,
        startIndex: item.startIndex > maxIndex ? maxIndex : item.startIndex,
      },
    });
  }

  onHeightChanged = (event: React.ChangeEvent<HTMLInputElement>) => this.setState({
    ...this.state,
    item: {
      ...this.state.item,
      height: event.target.value,
    },
  })

  onStartIndexChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { item } = this.state;
    let startIndex = event.target.value;
    const copy = [...item.disabledIndices];

    if (+startIndex < 0) {
      startIndex = '0';
    }

    if (+startIndex > (item.width * item.height - 1)) {
      startIndex = `${item.width * item.height - 1}`;
    }

    const disabledIndex = copy.indexOf(+startIndex);

    if (disabledIndex !== -1) {
      copy.splice(disabledIndex, 1);
    }

    this.setState({
      ...this.state,
      item: {
        ...this.state.item,
        startIndex,
        disabledIndices: copy,
      },
    });
  }

  onCropChanged = (data: Blob | null, crop: ImageCropper.Crop) => {
    this.setState({
      ...this.state,
      item: {
        ...this.state.item,
        crop,
        fileToUpload: data,
      },
    });
  }

  onDisabledIndicesChange = (indices: number[]) => this.setState({
    ...this.state,
    item: {
      ...this.state.item,
      disabledIndices: indices,
    },
  })

  onPaidChange = () => {
    const { item } = this.state;
    const index = item.properties.indexOf('PAID');
    let copy = [...item.properties];

    if (index === -1) {
      copy = copy.concat('PAID');
    } else {
      copy.splice(index, 1);
    }

    this.setState({
      ...this.state,
      item: {
        ...item,
        properties: copy,
      },
    });
  }

  onSubmit = () => {
    const { item } = this.state;
    this.props.onSubmit({
      ...item,
      id: item.id ? item.id : new Date().getTime().toString(10),
    });
  }

  isSubmitDisabled = () => {
    const { item } = this.state;
    return (!item.fileToUpload && !item.imageUrl) ||
      !item.width ||
      !item.height ||
      !item.startIndex.toString();
  }

  render() {
    const { onClose } = this.props;
    const { item, chosenFile } = this.state;

    return (<Dialog
      title={`${item.id ? 'Edit' : 'Add new'} item`}
      onClose={onClose}
    >
      <div className={style.inputs}>
        <Input
          autoFocus
          type="file"
          hint="Choose item file:"
          className={style.fileInput}
          onChange={this.onFileChosen}
        />
        <Input
          type="number"
          hint="Width:"
          className={style.widthInput}
          value={item.width}
          onChange={this.onWidthChanged}
          min={2}
          max={10}
        />
        <Input
          disabled
          type="number"
          hint="Height:"
          className={style.heightInput}
          value={item.height}
          onChange={this.onHeightChanged}
          min={2}
          max={10}
        />
        <Input
          type="number"
          hint="Start sector index:"
          className={style.startInput}
          value={item.startIndex}
          onChange={this.onStartIndexChanged}
        />
        <DisabledIndices
          value={item.disabledIndices}
          onChange={this.onDisabledIndicesChange}
        />
        <label className={style.paidInput}>
          <Input
            className={style.paidCheckbox}
            type="checkbox"
            checked={item.properties.indexOf('PAID') !== -1}
            onChange={this.onPaidChange}
          /> Paid
        </label>
        <Button
          secondary
          text="OK"
          disabled={this.isSubmitDisabled()}
          onClick={this.onSubmit}
        />
      </div>
      <div className={style.columns}>
        <div className={style.leftColumn}>
          <Cropper
            source={!!item.originalFile ? item.originalFile :
              item.imageUrl ?
                `${config.apiUrl}/cors/?url=${item.imageUrl}` :
                null}
            crop={item.crop}
            onChange={this.onCropChanged}
          />
        </div>
        <div className={style.rightColumn}>
          <Indices
            onChange={this.onDisabledIndicesChange}
            disabledIndices={item.disabledIndices}
            startIndex={+item.startIndex}
            preview={!!item.fileToUpload ? item.fileToUpload :
              item.imageUrl ? `${config.apiUrl}/cors/?url=${item.imageUrl}` : null}
            width={item.width}
            height={item.height}
          />
        </div>
      </div>
    </Dialog>);
  }
}
